import StorageServices from "../services/storageServices";

export default function useActiveStoreKey() {
  const keys = StorageServices.get("active-buyer-store-keys");
  if (!keys) return;
  return JSON.parse(StorageServices.get("active-buyer-store-keys"));
}
